import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colour = variables.colour;
var bodySmallBold = typography.bodySmallBold;
export var button = /*#__PURE__*/css("margin-top:12px;margin-left:0;", bodySmallBold, ";cursor:pointer;:focus{background-color:", colour.white, ";}");
export var chevron = /*#__PURE__*/css("color:", colour.neutral500, ";margin-top:-1px;");
export var wrapper = {
  name: "1fsnuue",
  styles: "overflow-anchor:none;"
};